import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { CouponsState, SLICE_NAME } from './models';

const couponsSelector = (state: RootState): CouponsState => state[SLICE_NAME];

export const selectCoupons = createSelector(couponsSelector, (state: CouponsState) => state.coupons);

export const selectCouponsIsLoading = createSelector(couponsSelector, (state: CouponsState) => state.isLoading);

export const selectCouponsError = createSelector(couponsSelector, (state: CouponsState) => state.error);
